import React, { Suspense, useEffect, useRef, useState } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import "./style.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Virtual, Navigation } from "swiper/modules";
import StoryModalTemplate from "@components/StoryModalTemplate";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/virtual";
import ArrowTip from "@assets/arrow-tip-right.svg";
import { fetchData, useWindowSize } from "../../Helpers";
import { useNavigate } from "react-router";
import JourneyStory from "./JourneyStory";
import {
  StoryHeader,
  StoryTimelineComponent,
} from "@components/StorySwiperModal";
import { joutneyData } from "./data";
import { BackgroundComponent } from "@pages/InspirationClubBrithday/BackgroundComponent";
import Loader from "@components/Loader";
import { useQueryClient } from "@tanstack/react-query";

export default NiceModal.create(() => {
  const modal = useModal();
  const swiperRef = useRef(null);
  const { width } = useWindowSize();
  const navigate = useNavigate();
  const [storyArray, setStoryArray] = useState([]);
  const stories = joutneyData;
  const selectedStories = useRef([]);
  const [delayLoad, setDelayLoad] = useState(true);
  const [delayLoadCanvas, setDelayLoadCanvas] = useState(true);
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState(null);

  const statsData = modal.args?.getData ?? (() => {});

  const getData = () => {
    const controller = new AbortController();
    fetchData({
      endpoint: "/activation/passport/birthday2025/journey",
      payload: null,
      successCallback: (resObj) => {
        setData(resObj.data);
        setTimeout(() => {
          setDelayLoadCanvas(false);
        }, 500);
        setTimeout(() => {
          setDelayLoad(false);
        }, 1000);
        if (resObj.data) {
        }
      },
      controller: controller,
      shouldThrowError: true,
    });
  };

  useEffect(() => {
    if (!data) getData();
  }, []);

  if (selectedStories.current.length === 0) {
    storiesFilter();
  }

  const initialStory = modal.args?.initialStoryUUID
    ? selectedStories.current?.findIndex(
        (e) => e.uuid === modal.args?.initialStoryUUID
      ) ?? 0
    : 0;
  const [isAssetReady, setIsAssetReady] = useState(false);
  const [currentIndexInGroup, setCurrentIndexInGroup] = useState(0);
  const [pauseStory, setPauseStory] = useState(false);
  const storyUUIDsByOrder = selectedStories.current.map((e) => e?.uuid);
  const isGoingBack = useRef(false);
  let flatData = stories?.flat() ?? [];
  const initialStoryVirtualIndex = flatData.findIndex(
    (e) => e.uuid === storyUUIDsByOrder[initialStory]
  );
  const [currentGroup, setCurrentGroup] = useState(initialStoryVirtualIndex);

  const [isRewardAvilable, setIsRewardAvilable] = useState(
    data?.rewardAvailable
  );
  const queryClient = useQueryClient();
  const [awardLoading, setAwardLoading] = useState(false);

  useEffect(() => {
    if (!data) return;

    let filteredStories = flatData.map((story) => story.stories);

    // if (data?.coupon === null && data?.brand === null) {
    //   filteredStories = filteredStories.map((storyGroup) =>
    //     storyGroup.filter((story) => story.ident !== "red-1")
    //   );
    // }

    setStoryArray(filteredStories);
    setLoading(false);
  }, [data]);

  useEffect(() => {
    if (data?.rewardAvailable !== undefined) {
      setIsRewardAvilable(data.rewardAvailable);
    }
  }, [data]);

  useEffect(() => {
    if (isGoingBack.current) {
      swiperRef.current.swiper.slideTo(currentGroup + 1, 0, false);
      setCurrentGroup((prev) => prev + 1);
      isGoingBack.current = false;
    }
  }, [storyArray]);

  const groupsLength = storyUUIDsByOrder?.length ?? 0;
  const currentGroupLength = storyArray?.[currentGroup]?.length ?? 0;

  function storiesFilter() {
    if (modal.args?.singleStory) {
      selectedStories.current = stories?.filter(
        (item) => item.ident === modal.args?.singleStory
      );
      return;
    }

    selectedStories.current = stories;
    return;
  }

  function prevStoryInGroup(e) {
    e.stopPropagation();
    if (currentIndexInGroup === 0) {
      if (currentGroup === 0) {
        return;
      }
      swiperRef.current.swiper.slideTo(
        swiperRef.current.swiper.activeIndex - 1
      );
      setCurrentIndexInGroup(storyArray[currentGroup - 1]?.length - 1);
      setIsAssetReady(false);
      return;
    }
    setCurrentIndexInGroup((prev) => --prev);
  }

  function nextStoryInGroup(e) {
    if (e) {
      e.stopPropagation();
    }
    if (currentIndexInGroup === currentGroupLength - 1) {
      if (flatData[currentGroup].uuid === storyUUIDsByOrder[groupsLength - 1]) {
        closeStories();
        return;
      }
    }

    setCurrentIndexInGroup((prev) => ++prev);
  }

  function closeStories() {
    if (modal?.args?.closePath) {
      navigate(modal?.args?.closePath);
    }
    modal.hide();
    document.querySelector("body").classList.remove("ReactModal__Body--open");
  }

  function redeemAward() {
    fetchData({
      endpoint: "/activation/passport/birthday2025/journey-seen",
      successCallback: (resObj) => {
        console.log(" reward collected");
        getData();
        setAwardLoading(false);
        setIsRewardAvilable(false);
        queryClient.refetchQueries({
          queryKey: ["user-details"],
        });
        statsData();
      },
      errorCallback: (resObj) => {
        setAwardLoading(false);
        setIsRewardAvilable(false);
      },
    });
  }

  useEffect(() => {
    if (currentIndexInGroup === 8 && isRewardAvilable && !awardLoading) {
      setAwardLoading(true);
      setIsRewardAvilable(false);
      redeemAward();
    }
  }, [currentIndexInGroup, isRewardAvilable, awardLoading]);

  if (storyArray.length !== 0 && initialStoryVirtualIndex !== -1) {
    return (
      <StoryModalTemplate
        isOpen={modal.visible}
        onClose={() => {
          closeStories();
        }}
        onAfterClose={() => modal.remove()}
      >
        {width >= 1020 && (
          <>
            <button
              onClick={prevStoryInGroup}
              className="swiper-button-prev stories"
            >
              <img src={ArrowTip} alt="" />
            </button>
            <button
              onClick={nextStoryInGroup}
              className="swiper-button-next stories"
            >
              <img src={ArrowTip} alt="" />
            </button>
          </>
        )}
        <Swiper
          navigation={{
            nextEl: ".swiper-slide.swiper-slide-next",
            prevEl: ".swiper-slide.swiper-slide-prev",
          }}
          modules={[Virtual, Navigation]}
          initialSlide={initialStoryVirtualIndex}
          slidesPerView={width >= 1020 ? "auto" : 1}
          ref={swiperRef}
          onBeforeInit={() => {
            setCurrentGroup(initialStoryVirtualIndex);
          }}
          onSlidePrevTransitionStart={(index) => {
            isGoingBack.current = true;

            setCurrentGroup(index.activeIndex);
            setCurrentIndexInGroup(0);
          }}
          onSlideNextTransitionStart={(index) => {
            setCurrentGroup(index.activeIndex);
            setCurrentIndexInGroup(0);
          }}
          longSwipes={false}
          className="main-story-swiper"
          centeredSlides={true}
          lazyPreloadPrevNext={1}
          virtual={width <= 1020 && true}
        >
          {storyArray.map((storiesGroup, groupIndex) => (
            <SwiperSlide
              key={groupIndex}
              onClick={() => {
                if (currentGroup !== groupIndex) {
                  swiperRef.current.swiper.slideTo(
                    swiperRef.current.swiper.clickedIndex
                  );
                }
              }}
            >
              <div className="stories-group-wrapper journey ">
                {delayLoad && <Loader show={true} blackBg={true} />}
                <Suspense fallback={<Loader show={true} blackBg={true} />}>
                  {!delayLoadCanvas && (
                    <BackgroundComponent
                      page={storiesGroup[currentIndexInGroup].page}
                      scene={storiesGroup[currentIndexInGroup].scene}
                    />
                  )}
                </Suspense>
                {storiesGroup.map((e, index) => {
                  // initial story
                  const isCurrentStroy =
                    groupIndex === currentGroup &&
                    index === currentIndexInGroup;

                  return (
                    <div
                      className={`story-wrapper ${
                        groupIndex === currentGroup
                          ? index === currentIndexInGroup
                            ? "visible"
                            : ""
                          : index === 0
                          ? "visible"
                          : ""
                      }`}
                      key={index}
                    >
                      <StoryHeader
                        title={"Inspiration Journey 2025"}
                        groupIndex={groupIndex}
                        currentGroup={currentGroup}
                        setPauseStory={setPauseStory}
                        pauseStory={pauseStory}
                      />

                      <div className="story-contnet">
                        {currentGroup === groupIndex && (
                          <StoryTimelineComponent
                            storiesInGroup={storiesGroup}
                            lenght={currentGroupLength}
                            stopAnimation={pauseStory}
                            onAnimationComplete={() => {
                              if (currentIndexInGroup === index)
                                nextStoryInGroup();
                            }}
                            isAssetReady={isAssetReady}
                            currentIndexInGroup={currentIndexInGroup}
                            hideMarkers={true}
                          />
                        )}

                        <JourneyStory
                          img={e.img}
                          currentIndexInGroup={
                            currentGroup === groupIndex
                              ? currentIndexInGroup
                              : 0 // initial slide
                          }
                          ident={e.ident}
                          setIsAssetReady={setIsAssetReady}
                          isStoryPaused={pauseStory}
                          isCurrentGroup={groupIndex === currentGroup}
                          isCurrentStory={isCurrentStroy}
                          closeStories={closeStories}
                          content={e.content}
                          data={data}
                          loading={loading}
                          getData={getData}
                        />

                        {isCurrentStroy && (
                          <div className="story-navigation">
                            <div
                              onClick={(e) => prevStoryInGroup(e)}
                              className="prev"
                            />
                            <div
                              onClick={(e) => nextStoryInGroup(e)}
                              className="next"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </StoryModalTemplate>
    );
  }
});
